import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IPOSLocation, menuPosApi } from 'components/menu/MenuPosApi';
import { AppDispatch } from '../store';

export interface PosLocationsState {
    posLocations: IPOSLocation[];
    loading: boolean;
}

export const initialState: PosLocationsState = {
    posLocations: [],
    loading: false
};

const posLocationsSlice = createSlice({
    name: 'posLocations',
    initialState,
    reducers: {
        startRequest: state => {
            state.loading = true;
        },
        endRequest: state => {
            state.loading = false;
        },
        loadSuccess: (state, action: PayloadAction<IPOSLocation[]>) => {
            state.posLocations = action.payload;
            state.loading = false;
        },
        loadError: state => {
            state.loading = false;
        },
        resetPosLocations: () => ({ ...initialState })
    }
});

export const { resetPosLocations } = posLocationsSlice.actions;
const { startRequest, endRequest, loadSuccess, loadError } = posLocationsSlice.actions;

export const getPosLocations = () => async (dispatch: AppDispatch) => {
    dispatch(startRequest());
    try {
        const result = await menuPosApi.getList();
        if (result.ok) {
            dispatch(loadSuccess(result.body.items));
        } else {
            dispatch(loadError());
        }
    } catch {
        dispatch(loadError());
    } finally {
        dispatch(endRequest());
    }
};

export default posLocationsSlice.reducer;
